import { useRootStore } from '@/stores/root.store';
import { useUserStore } from '@/stores/user.store';
import { v4 as uuidv4 } from 'uuid';

export default async (to) => {
  // if route isn't authenticated, next
  if (!to.meta?.authenticated) return true;

  // if user has a session, next
  const userStore = useUserStore();
  if (userStore.hasSession) return true;

  // if user is not authenticated, save 'to' route to cookie
  useRootStore().cookieService.setRedirectToCookie(to.fullPath);

  // redirect to login via oauth
  const { backendAuthUrl, oidCallbackUrl, oidClientId } = useRootStore().configuration;
  const state = uuidv4();
  const host = `${backendAuthUrl}/oauth2/authorize`;
  const params = `?response_type=code&scope=openid&redirect_uri=${oidCallbackUrl}&client_id=${oidClientId}&state=${state}`;
  const url = `${host}${params}`;

  // save state to cookie
  useRootStore().cookieService.setStateToCookie(state);

  // redirect to oauth flow, see you on the other side
  window.location.href = url;
  return false;
};
